import { Component, OnInit, inject, signal, computed } from '@angular/core';
import { InscripcionesService } from '../Common/inscripciones.service';
import { ModalWindowService } from '../Common/modal-window/modal-window.service';
import { DialogFacturaComponent } from './dialog-factura/dialog-factura.component';
import { environment } from '../../environments/environment';
import { SHARED_IMPORTS, SHARED_DECLARATIONS } from '../Common/shared.config';

// Definimos los estados como constantes para evitar errores de tipeo
const STATUS_OK = 'ok';
const STATUS_EP = 'confirmando';
const STATUS_KO = 'ko';

@Component({
    selector: 'app-web-inscripciones-finish',
    templateUrl: './web-inscripciones-finish.component.html',
    styleUrls: [
        '../Common/page.scss',
        './web-inscripciones-finish.component.scss'
    ],
    standalone: true,
    imports: [...SHARED_IMPORTS, ...SHARED_DECLARATIONS]
})
export class WebInscripcionesFinishComponent implements OnInit {
    // Exponemos las constantes para que el HTML pueda leerlas directamente
    public readonly STATUS_OK = STATUS_OK;
    public readonly STATUS_EP = STATUS_EP;
    public readonly STATUS_KO = STATUS_KO;

    // Inyección de dependencias moderna sin usar constructor
    private _InscripcionesS = inject(InscripcionesService);
    private _ModalWindowS = inject(ModalWindowService);

    // Estado reactivo usando Signals
    public resultado_pago = signal<string>(STATUS_KO);
    
    // Convertimos propiedades a signals
    public inscripcion_data = signal<any>(null);
    public lista_invitados = signal<any[]>([]);
    public server_error = signal<string>('');
    public event_name = environment.event_name;
    public event_year = environment.event_year;

    // Computed signals para valores derivados
    public hasInvitedGuests = computed(() => this.lista_invitados().length > 0);
    public hasInvoiceAmount = computed(() => this.inscripcion_data()?.importe_factura);
    public isPaymentSuccessful = computed(() => this.resultado_pago() === STATUS_OK);

    ngOnInit(): void {
        this.server_error.set('');
        this.resultado_pago.set(STATUS_KO);

        // Inicializamos los datos en el ciclo de vida correcto
        this._InscripcionesS.readInscriptionData();
        this.inscripcion_data.set(this._InscripcionesS.inscription_record);
        this.lista_invitados.set(this._InscripcionesS.lista_invitados || []);

        if (this._InscripcionesS.dataIdStored) {
            console.log("Datos encontrados");
            this.confirmarInscripcion();
        } else {
            alert('No encontrados en stored');
        }
    }

    public confirmarInscripcion() {
        // Actualizamos la señal a "en proceso"
        this.resultado_pago.set(STATUS_EP);

        this._InscripcionesS.confirmarInscripciones().subscribe({
            next: () => {
                // Vaciamos las listas de forma segura
                this._InscripcionesS.lista_invitados = [];
                this.lista_invitados.set([]);

                // Notificamos el éxito a la pantalla a través de la señal
                this.resultado_pago.set(STATUS_OK);
            },
            error: (e: string) => {
                this.resultado_pago.set(STATUS_KO);
                const ids = sessionStorage.getItem('data_ids') || '{"error": "no encontrados"}';
                console.error("Error confirmado inscripción", JSON.parse(ids), e);
                this.server_error.set(e);
            }
        });
    }

    public openWindowFacturas() {
        this._ModalWindowS.showComponent(
            DialogFacturaComponent,
            this.inscripcion_data(),
            ['message-window']
        ).subscribe((datos_facturacion: any) => {
            if (datos_facturacion) {
                // TODO: Enviar mail con los datos de facturación al col·legi
            }
        });
    }

    public descargarAcreditacion() {
        // Implementación pendiente
    }
}
